<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="30%"
    append-to-body
    top="5vh"
  >
    <!-- <div class="container">
      <img src="./img/dialog-bg.png" class="bg-img" alt="" />
      <div class="content">
        <div>大渡口区</div>
        <div style="width: 100%" class="mt-10">
          <el-input v-model="key" placeholder="搜索小区">
            <div slot="suffix">
              <div
                class="flex justify-center items-center cursor-pointer"
                style="height: 42px; width: 50px"
              >
                <img
                  @click="onSearch"
                  style="width: 20px; height: 20px"
                  src="./img/search.png"
                  alt=""
                />
              </div>
            </div>
          </el-input>
          <div class="list__container">
            <div
              v-for="(item, index) in filterList"
              :key="index"
              class="flex items-center item mt-5 pl-10 cursor-pointer"
              :class="selectItem.name == item.name ? 'active' : ''"
              @click="onCheckItem(item)"
            >
              <img
                src="./img/house.png"
                alt=""
                style="height: 20px; width: 20px"
              />
              <div class="ml-4">{{ item.name }}</div>
            </div>
          </div>

          <div slot="footer">
            <div
              class="flex justify-center items-center cursor-pointer"
              style="width: 100%; margin-top: 50px"
              @click="handleSubmit"
            >
              <dv-decoration-11
                style="width: 200px; height: 60px"
                :color="['#456AD6', '#456AD6']"
                >确 定</dv-decoration-11
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <f-select :list="list" @submit="handleSubmit" :value.sync="key"></f-select>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { communityList } from "../../mock.js";
export default {
  data() {
    return {
      key: "",
      filterList: [],
      list: [],
      selectItem: {},
      communityList,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(n) {
      n && this.init();
    },
  },
  computed: {
    ...mapGetters(["globalData", "mapKey", "tapMapCount"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
    // list() {
    //   return this.globalData.communities.map((v) => {
    //     return {
    //       name: v,
    //     };
    //   });
    // },
  },
  methods: {
    init() {
      this.key = "";
      console.log("this.mapKey", this.mapKey);
      this.$axios
        .get(`/statisticsService/street/community?subDistrict=${this.mapKey}`)
        .then((resp) => {
          this.list = resp.data;
        });
      // let list = this.communityList[this.mapKey].map((v) => {
      //   return {
      //     name: v,
      //   };
      // });
      this.filterList = list;
      this.selectItem = {};
    },
    handleSubmit() {
      // this.$store
      //   .dispatch("app/getGlobalData", { key: this.selectItem.name })
      //   .then((resp) => {});
      // this.visible = false;
      // ...mapMutations("/app"),
      this.$store.commit("app/SET_COMMUNIT_KEY", this.key);
      this.$store.commit("app/SET_TAP_MAP_COUNT", this.tapMapCount + 1);

      this.$store.dispatch("app/getGlobalData").then((resp) => {
        if (!resp) {
          this.$store.commit("app/SET_COMMUNIT_KEY", "");
          return;
        }
        this.$store.commit("app/SET_KEY", "street");
        this.$emit("onSave");
      });
      this.visible = false;
    },
  },
  mounted() {
    this.filterList = this.list;
  },
};
</script>
<style scoped lang="less">
.container {
  position: relative;
  .bg-img {
    position: absolute;
  }
  .content {
    position: relative;
    z-index: 2;
    color: #fff;
    padding-top: 6%;
    padding-left: 30px;
    padding-right: 30px;
    font-weight: bold;
    font-size: 20px;
  }
  .list__container {
    margin-top: 30px;
    height: 370px;
    overflow: scroll;
    .item {
      width: 100%;
      height: 39px;
      background: linear-gradient(
        90deg,
        #161f4e 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
      //   opacity: 0.28;

      font-size: 16px;
      color: #01b3e6;
      font-weight: 500;
    }
    .item:hover {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
    .active {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
  }
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-input__inner {
//     height: 42px;
//     border: 1px solid #077fd4;
//     border-radius: 8px;
//     background: none;
//     color: #01b3e6;
//   }
//   .el-dialog__header {
//     height: 20px;
//     padding: 0;
//   }
// }
</style>
